import { login, setConfig } from "@scrile/tools/dist/oauth/facebook";
import config from "config";

setConfig({ appId: config.facebookAppId });

export default {
  login,
};
